(function () {
  function initTechTabsSwiper() {
    document.querySelectorAll(".technology-tabs").forEach((section) => {
      const tabsEl = section.querySelector(".techTabs");
      const imagesEl = section.querySelector(".techImages");

      if (!tabsEl || !imagesEl) return;

      if (tabsEl.swiper) tabsEl.swiper.destroy(true, true);
      if (imagesEl.swiper) imagesEl.swiper.destroy(true, true);
      const tabSwiper = new Swiper(tabsEl, {
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
      });
      new Swiper(imagesEl, {
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        thumbs: {
          swiper: tabSwiper,
        },
        observer: true,
        observeParents: true,
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initTechTabsSwiper);
  document.addEventListener("shopify:section:load", initTechTabsSwiper);
  document.addEventListener("shopify:section:select", initTechTabsSwiper);
})();
